import Rule from "../../../../common/rule";

export default class Single extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { match }) {
        return match.winnerId;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { match }) {
        // Only used when ScoringMode.BestOfSeries
        if (match.winnerId === match.away.teamId) {
            ruleContext.singlesWonAway++;
        } else {
            ruleContext.singlesWonHome++;
        }
    }
}
